import { Store } from 'pullstate';

const ApplicationStore = new Store({
    snackbarOpen: false,
    snackbarMessage: '',
    snackbarDuration: 3000,
    snackbarType: 'success',
    showSaving: false
});

export default ApplicationStore;